// eslint-disable-next-line import/prefer-default-export
export class ServiceMapper {
  static toDTO(entity) {
    return {
      // TODO: rename the baseForm to contractor
      //   TODO: add dynamic mapping of services
      contractor: entity.baseForm.company['@id'],
      subcontractor: entity.baseForm.subcontractor ? entity.baseForm.subcontractor['@id'] : null,
      driver: entity.baseForm.driver ? entity.baseForm.driver['@id'] : null,
      rides: [
        {
          // status: 'new',
          status: 'waiting_for_driver_acceptance',
          company: entity.service.company['@id'],
          position: 0,
          attachments: [],
          type: 'serviceCourseRide',
          serviceLocation: entity.baseForm.place['@id'],
          scheduledAt: `${entity.baseForm.date}T${entity.baseForm.time}:00+00:00`,
          number: entity.serviceRideNumber.toString(),
          services: entity.service.services.map((val) => ServiceMapper.serviceToDTO(val)),
        },
      ],
    };
  }

  static serviceToDTO(service) {
    return {
      serviceType: service.serviceType,
      locomotives: service.locomotives?.map((locomotive) => locomotive['@id']),
      additionalInfo: service.additionalInfo,
      attachments: service.attachments?.map((attachment) => ({
        mediaObject: attachment['@id'],
        type: 'document_for_work',
      })),
    };
  }

  static toReportDTO(entity) {
    return {
      billFromDriver: {
        distance: entity.distance,
        highwayCost: entity.highwayCost === '' ? null : entity.highwayCost,
        waitingHours: entity.waitingHours === '' ? null : entity.waitingHours,
        comment: entity.comment === '' ? null : entity.comment,
      },
    };
  }
}
